import React, { Component } from 'react'
import UnchainedP from '../unchained.jpg';

import { Jumbotron } from 'react-bootstrap';


export class Unchained extends Component {
    render() {
        return (
            <div>
                 <Jumbotron  style = {{margin:"5%"}}>
  
    <img
      className="d-block w-100"
      src={UnchainedP}
      alt="First slide"
    />
    </Jumbotron>
 


  
            </div>
        )
    }
}

    export default Unchained